import { Wallet } from '@ethersproject/wallet';
import { keccak256 as solidityKeccak256 } from '@ethersproject/solidity';
export function calculateHash(passId, signer) {
    return solidityKeccak256(['uint256', 'address'], [passId, signer]);
}
export function hashLeaves(data) {
    const hashedLeaves = [];
    for (let i = 0; i < data.length; i++) {
        hashedLeaves.push(calculateHash(data[i].passId, data[i].signer));
    }
    return hashedLeaves;
}
export function createLeavesFromMandalaOwners(startIndex, owners) {
    const leaves = [];
    for (let i = 0; i < owners.length; i++) {
        leaves.push({ passId: '' + (startIndex + i), signer: owners[i].id });
    }
    return leaves;
}
export function createLeavesFromPrivateKeys(startIndex, privateKeys) {
    const leaves = [];
    for (let i = 0; i < privateKeys.length; i++) {
        const privateKey = privateKeys[i];
        leaves.push({ passId: '' + (startIndex + i), signer: new Wallet(privateKey).address });
    }
    return leaves;
}
//# sourceMappingURL=salepass.js.map